import React, { Component } from 'react';
import { ChromePicker } from 'react-color';

class ColorPicker extends Component {
  state = {
    displayColorPicker: false,
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  render() {
    // console.log(this.props.name);
    // some default variables
    let buttonTextColor = '#fff';
    let borderColor = this.props.color;

    // logic for dynamic coloring, check to see if it's too white
    const rgb = this.props.color.slice(5, -1);
    // console.log(rgb);
    // make rgb into an array
    const rgb_array = rgb.split(",");
    // console.log(rgb_array[3]);
    // check to see if we need to change the text color
    if ((
        rgb_array[0] > 200 && rgb_array[1] > 200 && rgb_array[2] > 200) || 
        rgb_array[3] < .2 || 
        (rgb_array[0] > 220 && rgb_array[1] > 220) ||
        (rgb_array[1] > 220 && rgb_array[2] > 220) ||
        rgb_array[1] > 220
      ) {
      buttonTextColor = '#6D6D6D';
    }
    // check to see if we need to change the border color
    if ((
        rgb_array[0] > 200 && rgb_array[1] > 200 && rgb_array[2] > 200) || 
        rgb_array[3] < .2
      ) {
      borderColor = '#D4D8D4';
    }
    
    // css styles
    const popover = {
      position: 'absolute',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }
    const colorPicker_style = {
      display: 'block'
    }
    const btnColor = {
      margin: '10px',
      backgroundColor: this.props.color,
      border: '1px solid ' + borderColor,
      padding: '10px 15px',
      fontWeight: "bold",
      color: buttonTextColor,
      outline: 'none'
    }
    return (
      // <ChromePicker
      //   color={this.props.color} 
      //   onChange={this.props.onChange}/>

      <div style={colorPicker_style}>
        <button style={btnColor} onClick={ this.handleClick }>{this.props.name}</button>
        { this.state.displayColorPicker ? <div style={ popover }>
          <div style={ cover } onClick={ this.handleClose }/>
          <ChromePicker 
            color={this.props.color} 
            onChange={this.props.onChange}/>
        </div> : null }
      </div>
    );
  }
}

export default ColorPicker;